import { useContext, useEffect, useState } from "react";
import SinglePage from "../../pages/single/SinglePage";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/authContext";
import { db } from "../../matabase";
import { getDoc, doc, deleteDoc } from "firebase/firestore";

const Single = () => {
  const [err, setErr] = useState(null);
  const [load, setLoad] = useState(false);
  const [post, setPost] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser } = useContext(AuthContext);

  const postId = location.pathname.split("/")[2];

  useEffect(() => {
    const fetchData = async () => {
      setLoad(true);

      try {
        const res = await getDoc(doc(db, "posts", postId));
        if (res.exists()) {
          setPost(res.data());
        } else {
          console.log("no such document");
        }
      } catch (error) {
        console.log(error.message);
        setErr("Something went wrong");
      }
      setLoad(false);
    };
    fetchData();
  }, [postId]);

  const deleteBloge = async () => {
    setLoad(true);
    try {
      await deleteDoc(doc(db, "posts", postId));
      navigate("/");
    } catch (error) {
      console.log(error);
    }
    setLoad(false);
  };
  return (
    <div>
      {load ? (
        <p className="load-err">Loading...</p>
      ) : err ? (
        <p className="load-err">{err}</p>
      ) : Object.keys(post).length < 1 ? (
        <p className="load-err">{"blog does not exist"}</p>
      ) : (
        <>
          {currentUser && (
            <>
              <Link
                to={"/write"}
                className="btn btn-primary m-2"
                state={{ ...post, postId: postId }}
              >
                Edit
              </Link>
              <button onClick={deleteBloge} className="btn btn-danger m-2">
                Delete
              </button>
            </>
          )}
          <SinglePage post={post} deleteBloge={deleteBloge} />
        </>
      )}{" "}
    </div>
  );
};

export default Single;
